// reducer import

import authReducer from "./auth";
import usersReducer from "./user";
import messagesReducer from "./messages";
import roomReducer from "./room";
import sendBoxConnectReducer from "./sandBoxConnect";
import messageBoxConnectReducer from "./messageBoxConnect";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = {
  auth: authReducer,
  users: usersReducer,
  messages: messagesReducer,
  room: roomReducer,
  sendBoxConnect: sendBoxConnectReducer,
  messageBoxConnect: messageBoxConnectReducer,
};

export default reducer;
